<template>
  <el-select
    clearable
    @clear="clear"
    v-bind="$attrs"
    v-on="$listeners"
    :value="stringValue"
    @change="select"
    @visible-change="blur"
    :style="{width:width}"
    >
      <el-option
      :dataLabel="labels"
      :dataValues="values"
      :label="label"
      :value="key"
      :style="{width:width}"
      class="optionTree">
        <el-tree
          :data="treeData"
          default-expand-all
          ref="mySelectTree"
          :node-key="values"
          :props="{
            label:labels,
            children: 'children'
          }"
          show-checkbox
          :default-checked-keys="value || []"
          @check="getChecked"
          class="multree"
        >
          <!-- <span class="custom-tree-node1" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-if="data.mobile">({{data.jobName}})</span>
          </span> -->
        </el-tree>
      </el-option>
  </el-select>
</template>

<script>
export default {
  props:{
    treeData:{
      type:Array,
      default:function(){
        return []
      }
    },
    value: {
      type: [String,Array]
    },
    values: {
      type: String,
      default: "value"
    },
    labels: {
      type: String,
      default: "label"
    },
    width:{
      type:String,
      default:'auto'
    }
  },
  data(){
    return {
      label:'',
      key:'',
      keyList:[]
    }
  },
  computed:{
    stringValue(){
      let name = []
      if(!this.value){
        return this.value
      }
      this.value.forEach(item=>{
        name.push(this.treeData.find(v=>v[this.values] === item)[this.labels])
      })
      return name.join(';')
    }
  },
  methods:{
    getChecked(checkedNodes, checkedKeys){
      console.log(checkedNodes, checkedKeys)
      let keyList = []
      let labelList = []
      let checkNodes = checkedKeys.checkedNodes
      checkNodes.forEach(item => {
          keyList.push(item[this.values])
          labelList.push(item[this.labels])
      })
      // this.keyList = keyList
      this.$emit('input',keyList)
      this.key = keyList.join(';')
      this.label = labelList.join(';')
      this.$emit("select", keyList);
      // console.log(this.keyList)
    },
    clear() {
      this.$refs.mySelectTree.setCheckedKeys([])
      this.$emit("clear");
      this.$emit("select", []);
    },
    select (e) {
      this.$emit("select", e);
      console.log(e,"select")
    },
    blur (e) {
      this.$emit("blur",e);
      console.log(e,"blur")
    }
  },
  // created(){
  //   console.log(this.values,this.labels,this.value)
  // }
  
}
</script>

<style scoped>
.optionTree {
  /* width: 300px; */
  height: auto;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #fff;
}
.multree >>> .el-tree-node__content>.el-tree-node__expand-icon{
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/mulSelect/multipleSelect.vue